__turbopack_context__.v({
  "answer": "WFaq-module__FPxsxW__answer",
  "details": "WFaq-module__FPxsxW__details",
  "eyebrow": "WFaq-module__FPxsxW__eyebrow",
  "header": "WFaq-module__FPxsxW__header",
  "heading": "WFaq-module__FPxsxW__heading",
  "list": "WFaq-module__FPxsxW__list",
  "question": "WFaq-module__FPxsxW__question",
  "root": "WFaq-module__FPxsxW__root",
  "row": "WFaq-module__FPxsxW__row",
});
